<template>
  <router-view />
</template>

<script setup>
import { onMounted, onUnmounted } from "vue";

onMounted(() => {
  document.documentElement.classList.add("dark");
});

onUnmounted(() => {
  document.documentElement.classList.remove("dark");
});
</script>
